import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import {RestangularModule, Restangular} from 'ngx-restangular'
import {API_URL } from '../config';

@Injectable()
export class MapAssessmentService {
  private apiUrl = "/api/v1";
  private baseUrlNew = API_URL+"/api/v1";    //"https://qhsebe.ilooopsqhse.com/api/v1";



  constructor(private http: HttpClient, private restangular:Restangular) {}

  private getAuthToken(): string {
    return localStorage.getItem("access_token") || "";
  }

  private getHeaders(): HttpHeaders {
    const token = this.getAuthToken();
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  // Create a new Map Assessment with Authorization header
  createMapAssessment(mapAssessmentData: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.post(
      `${this.apiUrl}/assesm-type-map-assessments`,
      mapAssessmentData,
      {
        headers,
      }
    );
  }

  // Read all Map Assessments with Authorization header
  getAllMapAssessments(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.apiUrl}/assesm-type-map-assessments`, {
      headers,
    });
  }

  // Read a specific Map Assessment by ID with Authorization header
  getMapAssessmentById(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.baseUrlNew}/assesm-type-map-assessments/${id}`, {
      headers,
    });
  }

  // Update a Map Assessment by ID with Authorization header
  updateMapAssessment(id: number, mapAssessmentData: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(
      `${this.apiUrl}/assesm-type-map-assessments/${id}`,
      mapAssessmentData,
      { headers }
    );
  }

  // Delete a Map Assessment by ID with Authorization header
  deleteMapAssessment(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(
      `${this.apiUrl}/assesm-type-map-assessments/${id}`,
      {
        headers,
      }
    );
  }



  public addMapAssessmentAssessor() {
    return this.restangular.all("addMapAssessmentAssessor");
  }



}



// WEBPACK FOOTER //
// /app/src/app/services/map-assessment.service.ts